import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { translate } from '@vestahealthcare/common/i18n';
import { EMPTY } from '@vestahealthcare/common/utils/constants';

import { useCommonStyles } from './styles';

type ItemProps = {
  avoidTranslation?: boolean;
  children?: ReactNode;
  icon?: ReactNode;
  label: string;
  namespace?: string;
  noMarginBottom?: boolean;
};

export const DetailItem = ({
  avoidTranslation,
  children,
  icon,
  label,
  namespace,
  noMarginBottom,
}: ItemProps) => {
  const styles = useCommonStyles();
  return (
    <>
      <h4
        className={classNames(
          styles.itemLabel,
          noMarginBottom ? 'no-margin' : styles.itemMarginBottom,
          'grid-span-4',
        )}
        data-cy={`member-detail-${label}-label`}
      >
        {avoidTranslation
          ? label
          : translate(`personalDetails.${namespace}.${label}`)}
      </h4>
      {typeof children === 'string' ? (
        <p
          className={classNames(
            styles.itemValue,
            noMarginBottom ? 'no-margin' : styles.itemMarginBottom,
            `grid-span-${icon ? 7 : 8}`,
          )}
          data-cy={`member-detail-${label}-value`}
        >
          {children || EMPTY}
        </p>
      ) : (
        <div
          className={classNames(
            styles.itemValue,
            noMarginBottom ? 'no-margin' : styles.itemMarginBottom,
            `grid-span-${icon ? 7 : 8}`,
          )}
          data-cy={`member-detail-${label}-value`}
        >
          {children || EMPTY}
        </div>
      )}
      {icon && <div className="grid-span-1">{icon}</div>}
    </>
  );
};

type ColumnProps = { children?: ReactNode };

export const DetailColumn = ({ children }: ColumnProps) => {
  const styles = useCommonStyles();
  return (
    <div className={classNames(styles.column, 'grid-span-4 grid-wrapper')}>
      {children}
    </div>
  );
};
